module.exports = __webpack_public_path__ + "img/kouyi.12807de1.png";